/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Duration is the duration of aggregation that aggregates histogram data in a project.
 */
export var Duration;
(function (Duration) {
    Duration["HOURLY"] = "hourly";
    Duration["DAILY"] = "daily";
    Duration["WEEKLY"] = "weekly";
    Duration["MONTHLY"] = "monthly";
    Duration["DAYWISE_MONTH"] = "daywiseMonth";
})(Duration || (Duration = {}));
